import { Faqs, Header } from "@components";

import Button from "@mui/material/Button";
import CheckIcon from "@mui/icons-material/Check";
import { DefaultLayout } from "@layouts";
import Link from "next/link";
import { NextSeo } from "next-seo";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import { useTranslation } from "next-i18next";

const SchoolPage = ({ data }) => {
  const { seo, benefits, faqs } = data;
  const { t } = useTranslation("common");

  return (
    <>
      <NextSeo
        title={"Aditus | " + seo?.metaTitle}
        description={seo?.metaDescription}
        additionalMetaTags={[
          {
            name: "keywords",
            content: seo?.keywords?.toString() || [],
          },
        ]}
      />
      <DefaultLayout showBreadcrumbs={false} showHero={false}>
        <div className="relative flex flex-col items-center justify-center my-10">
          <Header label={t("pages.school.label")} title={t("pages.school.title")}>
            <div className="flex justify-center w-full pt-10 text-center">
              <div className="max-w-xl text-sm leading-snug text-center text-gray-700 dark:text-white md:text-base">
                <div className="space-y-3 text-start">
                  <h2 className="w-full mb-4 text-xl font-medium tracking-wide text-center">{benefits?.description}</h2>
                  {benefits.list?.length > 0 && (
                    <ul className="ml-4 space-y-1 tracking-wide list-inside">
                      {benefits?.list.map(({ name }, i) => (
                        <li className="flex space-x-2" key={i}>
                          <CheckIcon className="w-8 fill-green-600" fontSize="small" />
                          <span className="max-w-sm space-y-0">{name}</span>
                        </li>
                      ))}
                    </ul>
                  )}
                </div>
                <div className="flex flex-col items-center justify-center w-full mx-auto mt-10 space-y-4">
                  <Button className="w-full text-white bg-primary">
                    <Link
                      href={{
                        pathname: "/user/registration",
                        query: { type: "educational" },
                      }}
                    >
                      {t("buttons.sign_up")}
                    </Link>
                  </Button>
                  <div className="flex flex-row items-center justify-center">
                    <span className="text-sm text-gray-700 dark:text-white">{t("forms.already_registered")}</span>

                    <Link href="/user/login" passHref>
                      <a className="mx-1 text-sm text-primary">{t("buttons.login")}</a>
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </Header>
        </div>

        <Faqs faqs={faqs} />
      </DefaultLayout>
    </>
  );
};

export default SchoolPage;

export async function getServerSideProps({ locale }) {
  const basePath = process.env.NEXT_PUBLIC_STRAPI;
  const qs = "populate=deep";
  const lang = `locale=${locale}`;
  // DATA
  const getSchoolPage = await fetch(`${basePath}/school-page?${qs}&${lang}`);
  const schoolPage = await getSchoolPage.json();

  return {
    props: {
      data: schoolPage?.data?.attributes || {},
      ...(await serverSideTranslations(locale, ["common"])),
    },
  };
}
